module.exports = __webpack_public_path__ + "static/media/style_board.a1e26471.jpg";